import React, { useEffect, useState } from "react";
import { TextBox, Button } from "devextreme-react";
import ReactJson from "react-json-view";
import ScrollView from "devextreme-react/scroll-view";
import KeyboardShortCuts from "../helpers/KeyboardShortCuts";
import AceEditor from "react-ace";
import "ace-builds/src-noconflict/mode-json";
import "ace-builds/src-noconflict/theme-monokai";
import Beautify from "ace-builds/src-noconflict/ext-beautify";

export default ({ selected, setSelected, handleUpdate }) => {
  const [editorValue, setValue] = useState("");

  const { level, type, name, value, isJSON, levelIdName } = selected;

  const onValueChange = (e, name) => {
    const { value } = e;

    setSelected({ ...selected, [name]: value });
  };

  useEffect(() => {
    if (isJSON && typeof value === "string") {
      const editor = document.getElementById("blah2").env.editor;

      Beautify.beautify(editor.session);
      setValue(JSON.stringify(JSON.parse(value), null, 2));
    }
  }, [isJSON]);

  return (
    <ScrollView
      width="100%"
      height="100%"
      className="dx-card responsive-paddings"
    >
      <h6
        style={{
          marginRight: "0",
          marginBottom: "5px",
          marginTop: "0",
          marginLeft: "0",
        }}
      >
        Edit Configuration
      </h6>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          marginBottom: "20px",
        }}
      >
        <Button
          type="back"
          stylingMode="contained"
          onClick={() => setSelected({})}
        />
        <Button
          type="default"
          stylingMode="contained"
          onClick={() => {
            if (isJSON) {
              handleUpdate(editorValue);
            } else {
              handleUpdate(value);
            }
          }}
        >
          Save changes
        </Button>
      </div>
      <div style={{ marginBottom: "15px" }}>
        <span className="sub-title">Level</span>
        <TextBox
          placeholder="Level"
          value={level}
          showClearButton={true}
          readOnly={true}
        />
      </div>
      <div style={{ marginBottom: "15px" }}>
        <span className="sub-title">Level ID</span>
        <TextBox
          placeholder="Level ID"
          value={levelIdName}
          showClearButton={true}
          readOnly={true}
        />
      </div>

      <div style={{ marginBottom: "15px" }}>
        <span className="sub-title">Type</span>
        <TextBox
          placeholder="Type"
          value={type}
          showClearButton={true}
          readOnly={true}
        />
      </div>
      <div style={{ marginBottom: "15px" }}>
        <span className="sub-title">Name</span>
        <TextBox
          placeholder="Name"
          value={name}
          showClearButton={true}
          readOnly={true}
        />
      </div>

      {isJSON ? (
        <div style={{ marginBottom: "15px" }}>
          <span className="sub-title">Value</span>
          {/* <ReactJson
            src={src}
            style={{ marginTop: "10px" }}
            name={false}
            theme="monokai"
            enableClipboard={true}
            collapseStringsAfterLength={30}
            iconStyle="circle"
            onAdd={(e) => {
              setSelected({ ...selected, value: e.updated_src });
            }}
            onEdit={(e) => {
              setSelected({ ...selected, value: e.updated_src });
            }}
            onDelete={(e) => {
              setSelected({ ...selected, value: e.updated_src });
            }}
          />

          <KeyboardShortCuts /> */}

          <AceEditor
            placeholder="Enter configuration here"
            mode={"json"}
            theme="monokai"
            name="blah2"
            onChange={(value, _) => {
              setValue(value);
            }}
            // fontSize={14}
            width={"100%"}
            showPrintMargin={false}
            showGutter={true}
            highlightActiveLine={true}
            editorProps={{ $blockScrolling: true }}
            value={editorValue}
            setOptions={{
              enableBasicAutocompletion: true,
              enableLiveAutocompletion: true,
              enableSnippets: true,
              showLineNumbers: true,
              tabSize: 2,
            }}
          />
        </div>
      ) : (
        <div style={{ marginBottom: "15px" }}>
          <span className="sub-title">Value</span>
          <TextBox
            placeholder="Value"
            value={value}
            showClearButton={true}
            valueChangeEvent="keyup"
            onValueChanged={(e) => onValueChange(e, "value")}
          />
        </div>
      )}
    </ScrollView>
  );
};
